import { useQuery } from '@tanstack/react-query';

import { getYear, globalConst } from '..';

export const useYear = () => {
  const { data, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.GET_YEAR_DATA],
    queryFn: getYear
  });

  return { ...data, ...args };
};
